import appStoreSVG from '@assets/appstore.svg';
import googlePlayPNG from '@assets/googleplay.png';
import { useGetResources } from '@hooks/useGetResources';
import { type Lenke, LenkeType } from '@src/types/minhelseentities';
import { urlExists } from '@utils/utils';

import Button from '@helsenorge/designsystem-react/components/Button';
import Icon from '@helsenorge/designsystem-react/components/Icon';
import ArrowUpRight from '@helsenorge/designsystem-react/components/Icons/ArrowUpRight';

interface Props {
  verktoyLenker: Array<Lenke>;
  buttonRef?: React.RefObject<HTMLButtonElement | null>;
  startVerktoy: (lenkeType: LenkeType) => void;
  showArrowIcon?: boolean;
  className?: string;
  visibility: ButtonsVisibility;
}

// eslint-disable-next-line react-refresh/only-export-components
export enum ButtonsVisibility {
  ShowAll,
  ShowWebOnly,
  ShowAppOnly,
  HideAll,
}

const OpenVerktoyButtons = ({
  verktoyLenker,
  buttonRef,
  startVerktoy,
  showArrowIcon,
  className,
  visibility,
}: Props): React.JSX.Element | null => {
  const resources = useGetResources();
  if (!resources) {
    return null;
  }

  const showWebButton =
    (visibility === ButtonsVisibility.ShowAll || visibility === ButtonsVisibility.ShowWebOnly) &&
    urlExists(verktoyLenker, LenkeType.Standard);
  const showAppStoreButton =
    (visibility === ButtonsVisibility.ShowAll || visibility === ButtonsVisibility.ShowAppOnly) &&
    urlExists(verktoyLenker, LenkeType.NedlastingAppIphone);
  const showGooglePlayButton =
    (visibility === ButtonsVisibility.ShowAll || visibility === ButtonsVisibility.ShowAppOnly) &&
    urlExists(verktoyLenker, LenkeType.NedlastingAppAndroid);
  if (visibility === ButtonsVisibility.HideAll) {
    return null;
  }
  return (
    <>
      {showWebButton && (
        <div className={className ? className : 'details__button_flexWidth'}>
          <Button
            testId="standardUrlButton"
            ref={buttonRef}
            onClick={(): void => {
              startVerktoy(LenkeType.Standard);
            }}
            aria-label={`${resources.openButtonText} - ${resources.ariaLabel_externalPage}`}
          >
            {resources?.openButtonText}
            {showArrowIcon && <Icon svgIcon={ArrowUpRight} />}
          </Button>
        </div>
      )}
      {showAppStoreButton && (
        <div>
          <button
            id="appstoreUrlButton"
            data-testid="appstoreUrlButton"
            className="details__appButton"
            ref={buttonRef}
            onClick={(): void => {
              startVerktoy(LenkeType.NedlastingAppIphone);
            }}
          >
            <img src={appStoreSVG} alt={resources.appstore_altText} className="details__appStore" />
          </button>
        </div>
      )}
      {showGooglePlayButton && (
        <div>
          <button
            id="googleplayUrlButton"
            data-testid="googleplayUrlButton"
            className="details__appButton"
            ref={buttonRef}
            onClick={(): void => {
              startVerktoy(LenkeType.NedlastingAppAndroid);
            }}
          >
            <img src={googlePlayPNG} alt={resources.googleplay_altText} className="details__googlePlay" />
          </button>
        </div>
      )}
    </>
  );
};

export default OpenVerktoyButtons;
